<template>
    <div id="calendar">
        <section class="after-loop container" style="padding-right:0; padding-left:0; padding-bottom: 3rem;">
            <!-- Call to Action Well -->
            <div class="card text-center">
                <h5 class="card-title">활동 선택</h5>
                <div class="card-body">
                    <p>“참여하고 싶은 활동을 아래에서 선택하세요”</p>

                    <div class="row mobile-only" style="min-height: 56px;padding:0px 30px;">
                        <div :class="[c.class, 'col']" v-for="c in $root.$children[0].category">
                            <a href="#none;" @click="getListByCategory(c.code)">
                                <img v-if="excludeCategory.includes(c.code)" :src="require('@/assets/icon/'+c.class+'_off.png')"  class="filter_img" style="max-width:100px;" />
                                <img v-else="excludeCategory.includes(c.code)" :src="require('@/assets/icon/'+c.class+'_on.png')" class="filter_img" style="max-width:100px;" />
                            </a>
                        </div>
                    </div>

                    <div class="row pc-only" style="min-height: 56px;padding:0px 30px;">
                        <div class="col"></div>
                        <div :class="[c.class]" v-for="c in $root.$children[0].category" style="margin:10px;">
                            <a href="#none;" @click="getListByCategory(c.code)">
                                <img v-if="excludeCategory.includes(c.code)" :src="require('@/assets/icon/'+c.class+'_off.png')" style="max-width:100px;"  />
                                <img v-else="excludeCategory.includes(c.code)" :src="require('@/assets/icon/'+c.class+'_on.png')" style="max-width:100px;" />
                            </a>
                        </div>
                        <div class="col"></div>

                    </div>
                </div>

                <ActivityList page="0" size="8" query="activityJoinAbleNow:true,isFixedTop:true,"/>

                <div>
                    <!--<button @click="refreshEvents">Refresh</button>-->
                    <!--<button v-if="selected._id" @click="removeEvent">Remove</button>-->
                    <!--<pre>{{ selected }}</pre>-->
                    <full-calendar  :events="events" ref="fullCalendar" @event-selected="eventSelected" @event-created="eventCreated" :config="config"></full-calendar>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import ActivityList from '@/components/activity/ActivityList.vue';
import moment from 'moment';
    //import dayGridPlugin from '@fullcalendar/daygrid'

    export default {
        name: 'calendar',
        components: {
            ActivityList,
        },
        data() {
            return {
                events: [],
                //calendarPlugins:[dayGridPlugin],
                config: {
                    titleFormat: 'YYYY년 MM월',
                    height : 'auto',
                    defaultView: 'month',
                    locale: 'ko',
                    plugins: ['interaction', 'dayGrid', 'timeGrid'], //dayGridMonth,listWeek,monthBtn,dayGridMonth
                    noEventsMessage:"참여가능한 액티비티가 없습니다.",
                    views: {

                        week: {
                            titleFormat: 'YYYY년 MM월 DD일',
                        },

                    },
                    customButtons: {
                        prevBtn: {
                            text: '◀',
                            click : () =>  {
                                this.$refs.fullCalendar.fireMethod('prev')
                                this.endDate = this.$refs.fullCalendar.fireMethod('getView').end.format('YYYYMMDD')
                                this.startDate = this.$refs.fullCalendar.fireMethod('getView').start.format('YYYYMMDD')
                                this.getList();
                            }
                        },
                        nextBtn: {
                            text: '▶',
                            click : () =>  {
                                this.$refs.fullCalendar.fireMethod('next')
                                this.startDate = this.$refs.fullCalendar.fireMethod('getView').start.format('YYYYMMDD')
                                this.endDate = this.$refs.fullCalendar.fireMethod('getView').end.format('YYYYMMDD')
                                this.getList();
                            }
                        },
                        monthBtn: {
                            text: '월',
                            click : () =>  {
                                this.$refs.fullCalendar.fireMethod('changeView', 'month');
                                this.startDate = moment(this.startDate).startOf('month').format('YYYYMMDD');
                                this.endDate = moment(this.endDate).endOf('month').format('YYYYMMDD');
                                this.getList();
                            }
                        },
                        listWeekBtn: {
                            text: '주',
                            click : () =>  {
                                this.$refs.fullCalendar.fireMethod('changeView', 'listWeek');
                                this.startDate = moment().weekday(0).format('YYYYMMDD');
                                this.endDate = moment().weekday(7).format('YYYYMMDD');
                                this.getList();
                            }
                        },
                    },
                    header: {
                        left: 'title,prevBtn,nextBtn',// ' today',
                        center: '',
                        right: 'listWeekBtn,monthBtn',//'dayGridMonth,timeGridWeek,timeGridDay'
                    },
                    editable: false,
                    eventLimit: true, // allow "more" link when too many events
                    //progressiveEventRendering: true,
                    eventClick: (event) => {
                        this.$router.push({ name: 'activityShow', params: { id: event.id }})
                    },
                },
                selected: {},
                startDate: moment().startOf('month').format('YYYYMMDD'),//moment().weekday(0).format('YYYYMMDD'),
                endDate: moment().endOf('month').format('YYYYMMDD'), //moment().weekday(7).format('YYYYMMDD'),
                excludeCategory: []
            };
        },
        methods: {

            refreshEvents() {
                this.$refs.calendar.$emit('refetch-events');
            },
            removeEvent() {
                this.$refs.calendar.$emit('remove-event', this.selected);
                this.selected = {};
            },
            eventSelected(event) {
                this.selected = event;
                //console.log(this.selected)
            },
            eventCreated(test) {
                //console.log(test);
            },
            getList() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/${me.startDate}/${me.endDate}?query=${this.excludeCategory}`)
                    .then(function (res) {
                        me.events = [];
                        for (let i = 0; i < res.data.length; i++) {
                            me.events.push({
                                id: res.data[i].id,
                                title: res.data[i].title,
                                start: res.data[i].activityStartDate,
                                allDay: false,
                                color: res.data[i].categoryColor,
                                description: res.data[i].activityPlaceName,
                            })
                        }
                    }).catch(function (error) {
                    console.log(error);
                    //alert(' 에러');
                });
            },

            getListByCategory(categoryCode) {
                if (this.excludeCategory.includes(categoryCode)) {
                    this.excludeCategory = this.excludeCategory.filter(function (value, index, arr) {
                        return value != categoryCode;
                    });
                } else {
                    this.excludeCategory.push(categoryCode)
                }
                //console.log(this.excludeCategory)

                this.getList()

            },
        },
        created() {
            this.getList()
        },
        computed: {},
    };
</script>

<style>
    @import '~fullcalendar/dist/fullcalendar.css';
.fc-left div h2{
    float:right;
    margin-left:10px;
    font-size:28px;
}
#calendar .fc-toolbar {
    background-color: #f8f7fc;
    padding:10px;
}
.fc-toolbar.fc-header-toolbar {
    margin-bottom: 0 !important;
    border-top: 1px solid #d9d9d9;
}
    #calendar .fc-toolbar button{
        color: #69ace5;
        background-color: #ffffff !important;
        border-radius: 0 !important;
        border: solid 1px #d9d9d9 !important;
        font-size: 13px !important;
        margin-top: 3px;
        margin-right: 3px;
    }

</style>